module.exports = __webpack_public_path__ + "img/pro_two_1.cbc61bba.jpg";